import { SlideTeamType, TeamType } from 'src/types';
// import ImageCarousel from '@components/ImageCarousel/ImageCarousel'

import './TeamCard.css';

const SocialButtons = ({ slide }: { slide: SlideTeamType }) => {
	return (
		<div className="social-buttons">
			{(slide as TeamType)?.linkedin && (
				<a
					target="_blank"
					rel="noreferrer noopener"
					className="icon icon-linkedin"
					href={`https://www.linkedin.com/in/${(slide as TeamType).linkedin}`}
					title="linkedin link"
				/>
			)}
			{(slide as TeamType)?.mail && (
				<a
					target="_blank"
					rel="noreferrer noopener"
					className="icon icon-envelope"
					href={`mailto:${(slide as TeamType).mail}`}
					title="email link"
				/>
			)}
		</div>
	);
};

const TeamCard = ({ slide, isCurrent }: { slide: SlideTeamType; isCurrent?: boolean }) => {
	const { image, name, summary, id, position } = slide;
	return (
		<article id={`team-card-${id}`} className={`team-card ${isCurrent ? 'current-slide' : ''}`}>
			{/* {(slide as TeamType)?.fake && (
        <div className="fake-image-bg">
          <ImageCarousel images={(slide as TeamType)?.fake} />
          <SocialButtons slide={slide} />
        </div>
      )} */}
			<header>
				<section className="left-side">
					<h1 className="title">{name}</h1>
					<h2 className="position">{position}</h2>
				</section>
				<section className="right-side">
					<SocialButtons slide={slide} />
					<div className="wrapper-image">
						<div className="team-card-image" style={{ backgroundImage: `url(${image})` }} />
						{(slide as TeamType)?.fake && (
							<div
								className="team-card-image fake-image"
								style={{
									backgroundImage: `url(${(slide as TeamType)?.fake[0]})`
								}}
							/>
						)}
					</div>
				</section>
			</header>
			<section className="team-card-info">
				<p className="summary truncate">{summary}</p>
			</section>
		</article>
	);
};

export default TeamCard;
